import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import type { IShowing } from 'src/api/landlord-showings-api';

type IConfirmTourResponse = {
    tour: Omit<IShowing, 'start_date'> & { start_date: string };
};


export type IConfirmTourPayload = {
    tourId: number;
    value: boolean
}

export const useConfirmShowing = () => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<
        IShowing,
        IStandardErrorResponse,
        IConfirmTourPayload
    >(
        async (payload) => {
            const res = await apiClient(`api/landlord/showings/${payload.tourId}/confirm`, {
                method: 'post',
                json: {
                    value: payload.value,
                },
            }).json<IConfirmTourResponse>();
            return res.tour;
        }, {
            onSuccess: () => {
                addNotification('Tour updated', 'success');
                // The showings query key now includes the date window, so a
                // prefix invalidation refreshes every loaded window (a fixed-key
                // setQueryData would no longer match any cached query).
                queryClient.invalidateQueries(queryKeys.showings);
            }, onError: (error) => {
                const errorMessage = error.msg || 'Failed to update tour';
                addNotification(errorMessage, 'error');
            }
        });
};
